<template>
	<div>
		<Popup
			v-model:show="scorePopup"
			position="bottom"
			closeable
			:style="{ height: '90%' }">
			<div style="font-size: var(--base-px-18);font-weight: bold;text-align: center;padding-top: var(--base-px-15);">
				客户评分
			</div>
			<Divider/>
			<div class="score_flex score_page">
				<div style="display: flex;width: calc(100% - var(--base-px-75));">
					<img src="../../../assets/60.jpg" alt="" style="width: var(--base-px-50);height: var(--base-px-50);">
					<div style="margin-left: var(--base-px-10);width: calc(100% - var(--base-px-60));">
						<div style="font-size: var(--base-px-16);font-weight: bold;">她守韶华向晚</div>
						<div class="score_flex" style="margin-top: var(--base-px-8);color: #999;">
							<van-tag type="warning">未设置</van-tag>
							<div>评分：<span style="font-size: var(--base-px-18);font-weight: bold;color: #2897FF;">0</span></div>
							<div>今日评分变化：<span>0</span></div>
						</div>
					</div>
				</div>
				<van-button type="primary" class="modify_score" @click="$refs.modifyScorePopup.show()">修改评分</van-button>
			</div>
			<Divider/>
			<div class="score_page">
				<div class="row_score_name">历史评分详情</div>
			</div>
			<Divider/>
			<div style="margin-top: var(--base-px-15);padding-bottom: var(--base-px-50);">
				<div class="member_modify_list" v-for="(item,index) in 1" :key="index">
					<div class="page_flex" style="font-size: var(--base-px-15);padding-left: var(--base-px-25);color:#9F9F9F;">
						<div>星期四 2021-09-02</div>
					</div>
					<Divider style="margin-top: var(--base-px-10);margin-bottom: var(--base-px-10);"/>
					<div style="padding-left: var(--base-px-20);">
						<Steps
							direction="vertical"
							active-icon="clock"
							inactive-icon="clock"
						>
							<Step>
								<div class="group_event">加入群聊</div>
								<div class="group_time">12:40 李国强加入群聊【123】</div>
							</Step>
							<Step>
								<div class="group_event">退出群聊</div>
								<div class="group_time">12:40 李国强退出群聊【123】</div>
							</Step>
						</Steps>
					</div>
				</div>
			</div>
		</Popup>
		<!--    修改评分弹窗-->
		<modifyScorePopup ref="modifyScorePopup"/>
	</div>
</template>
<script>
import {Popup, Divider, Step, Steps} from 'vant'
import modifyScorePopup from './modifyScorePopup'

export default {
	components: {
		Popup, Divider, Step, Steps, modifyScorePopup
	},
	data() {
		return {
			scorePopup: false
		}
	},
	methods: {
		show() {
			this.scorePopup = true
		}
	}
}
</script>
<style scoped lang="less">
.score_flex {
	display: flex;
	justify-content: space-between;
}

.score_page {
	padding: 0 var(--base-px-30) 0 var(--base-px-30);
	font-size: var(--base-px-28);
	color: #333;
}

.modify_score {
	font-size: var(--base-px-25);
	height: var(--base-px-50);
	padding: 0 var(--base-px-10) 0 var(--base-px-10);
}

.row_score_name {
	color: #333;
	font-size: var(--base-px-29);
	border-left: var(--base-px-7) solid #1890FF;
	height: var(--base-px-35);
	line-height: var(--base-px-40);
	padding-left: var(--base-px-10);
}

//步骤条
/deep/ .van-step__icon--active {
	color: #42A4FF;
}

/deep/ .van-step__circle-container {
	font-size: var(--base-px-30);
	color: #42A4FF;
}

/deep/ .van-step__title {
	color: #333;
}

.group_event {
	font-weight: bold;
}

.group_time {
	margin-top: var(--base-px-15);
	color: #747474;
}
</style>
